import { render, staticRenderFns } from "./LesiurpackageItemTheme2.vue?vue&type=template&id=8baa9eea&scoped=true"
import script from "./LesiurpackageItemTheme2.vue?vue&type=script&lang=js"
export * from "./LesiurpackageItemTheme2.vue?vue&type=script&lang=js"
import style0 from "./LesiurpackageItemTheme2.vue?vue&type=style&index=0&id=8baa9eea&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "8baa9eea",
  null
  
)

export default component.exports